import React from "react";
import ReactDOM from "react-dom/client";
import { DarkMode } from "@chakra-ui/react";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <div style={{ backgroundColor: "#1A202C" }}>
    <ChakraProvider>
      <DarkMode>
        <App />
      </DarkMode>
    </ChakraProvider>
  </div>
);
